module.exports = __webpack_public_path__ + "static/44-6e3c33fff80b50ad07fb51a720e7e3a4.jpg";